function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React, { useState, useEffect } from "react";
import { TopLevelContainer } from "@xo-union/tk-component-grid";
import BreadcrumbList from "./BreadcrumbList.js";
import styles from "./top_styles.css";
var TopBreadcrumb = function TopBreadcrumb(_ref) {
  var _ref$labels = _ref.labels,
    labels = _ref$labels === void 0 ? [] : _ref$labels,
    _ref$mobileTopLabels = _ref.mobileTopLabels,
    mobileTopLabels = _ref$mobileTopLabels === void 0 ? [] : _ref$mobileTopLabels,
    _ref$isMobile = _ref.isMobile,
    initialIsMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    _ref$trackingProps = _ref.trackingProps,
    trackingProps = _ref$trackingProps === void 0 ? {} : _ref$trackingProps;
  var _useState = useState(initialIsMobile),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    firstRender = _useState4[0],
    setFirstRender = _useState4[1];
  useEffect(function () {
    setFirstRender(false);
    var onWindowResize = function onWindowResize() {
      setIsMobile(window.innerWidth < 768);
    };
    onWindowResize();
    window.addEventListener("resize", onWindowResize);
    return function () {
      return window.removeEventListener("resize", onWindowResize);
    };
  }, []);
  var desktopLabels = function desktopLabels() {
    return labels;
  };
  var mobileLabels = function mobileLabels() {
    return mobileTopLabels.length && mobileTopLabels[0].link ? mobileTopLabels : [];
  };
  var breadcrumb = function breadcrumb(props) {
    return /*#__PURE__*/React.createElement(BreadcrumbList, _extends({}, props, {
      trackingProps: _objectSpread(_objectSpread({}, trackingProps), {}, {
        "data-user-decision-area": "top breadcrumb"
      })
    }));
  };
  var desktopBreadcrumb = function desktopBreadcrumb() {
    return breadcrumb({
      labels: desktopLabels(),
      className: styles["top-ol-desktop"]
    });
  };
  var mobileBreadcrumb = function mobileBreadcrumb() {
    return breadcrumb({
      labels: mobileLabels(),
      caretIconName: "caret_left",
      className: styles["top-ol-mobile"]
    });
  };
  var className = mobileLabels().length ? "" : "breadcrumb-container-none";
  return /*#__PURE__*/React.createElement("nav", {
    className: "".concat(styles["breadcrumb-container-top"], " ").concat(styles[className]),
    "aria-label": "breadcrumbs"
  }, firstRender || isMobile ? mobileBreadcrumb() : "", firstRender || !isMobile ? /*#__PURE__*/React.createElement(TopLevelContainer, null, desktopBreadcrumb()) : "");
};
export default TopBreadcrumb;